import request from '@/utils/request'

let Ma_new_meetingApi = {

  /*新建会议列表*/
  list(data) {
    return request._post('/shop/plus.ma_new_meeting.Index/index', data);
},
/*添加新建会议*/
add(data) {
    return request._post('/shop/plus.ma_new_meeting.Index/add', data);
},
/*修改新建会议*/
edit(data) {
    return request._post('/shop/plus.ma_new_meeting.Index/edit', data);
},
/*删除新建会议*/
del(data) {
    return request._post('/shop/plus.ma_new_meeting.Index/del', data);
},
/*新建会议详情*/
detail(data) {
  return request._post('/shop/plus.ma_new_meeting.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_new_meeting.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_new_meeting.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/export', data);
    },
    updateProgress(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/updateProgress', data);
    },
    getCheckInList(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/getCheckInList', data);
    },
    getEmployeeList(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/getEmployeeList', data);
    },
    addCheckIn(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/addCheckIn', data);
    },
    deleteCheckIn(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/deleteCheckIn', data);
    },
    getCheckOutList(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/getCheckOutList', data);
    },
    addCheckOut(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/addCheckOut', data);
    },
    deleteCheckOut(data) {
        return request._post('/shop/plus.ma_new_meeting.Index/deleteCheckOut', data);
    },
}
export default Ma_new_meetingApi;



// WEBPACK FOOTER //
// ./src/api/ma_new_meeting.js